import { PlusOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../AppContext';
import { ROUTES } from '../common/constants';
import useRouter from '../hooks/useRouter';
import { AppActionType, AppContextType } from '../types/appContext.type';

export default function AddFloorPlanButton() {
  const { dispatch } = useContext(AppContext) as AppContextType;
  const { navigate } = useRouter();

  const handleClick = () => {
    if (dispatch) {
      dispatch({ type: AppActionType.removeFloorPlanSequence });
    }
    navigate(ROUTES.UPLOAD_FLOOR_PLAN);
  };

  return (
    <FloatButton
      icon={<PlusOutlined />}
      className="add-floor-plan-btn"
      type="primary"
      tooltip="Add New Floor Plan"
      onClick={handleClick}
    />
  );
}
